let actu = {
    init() {
        if($('body').hasClass('page-node-type-actualites') || $('body').hasClass('page-node-type-pro-actualites') || $('body').hasClass('page-node-type-actualites-archives')){
            let bgcolor = $('.color').data('bgcolor');
            let pattern = $('.color').data('pattern');

            $('.block-list-1-last-article').css('background-color', bgcolor);
            $('.block-list-1-last-article .icon-pattern').css('color', pattern);

            let page = window.location.search;
            if((page == '')  || (page == '?page=0')){
                //console.log('show');
                $('body').addClass('show-first-actu');
            }else{
                //console.log('hide');
            }
        }
    }
}

export default actu;
